import React from "react";

const SearchPageContext = React.createContext();
export default SearchPageContext;
